import { useEffect, useState } from 'react'
import { api } from '../api'

export function useHealth() {
  const [status, setStatus] = useState<'ok' | 'error' | 'loading'>('loading')

  useEffect(() => {
    let mounted = true
    api.health()
      .then(() => { if (mounted) setStatus('ok') })
      .catch(() => { if (mounted) setStatus('error') })
    return () => { mounted = false }
  }, [])

  return status
}
